import { useEffect, useRef, useState } from "react";
import { GridHeader } from "../../components/Grid/Grid";
import WebService from "../../utility/WebService";
import PageTitle from "../../components/PageTitle/PageTitle";
import HelperService from "../../utility/HelperService";
import { permissionsInterface } from "../onBoarding/onBoardingTypes";
import { useSelector } from "react-redux";
import ExpandableGrid, { ExpandableRow } from "../../components/Grid/ExpandableGrid";

const headers: GridHeader[] = [
    {
        title: "Unit name",
        class: "text-center",
    },
    {
        title: "Area",
        class: "text-center",
    },
    {
        title: "Booking Date",
        class: "text-center",
    },
];

const BookedUnits = () => {
    const nextOffset = useRef<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [rows, setRows] = useState<ExpandableRow[]>([]);
    const token = useSelector((state: any) => state.OnBoardingReducer);
    const [permissions, setPermissions] = useState<permissionsInterface | null>(null);


    useEffect(() => {
        getExpenseList(0);
        if (token && token.token && token.permissions && !!token.permissions.length) {
            setPermissions(token.permissions.find((item: any) => item.name === "PROJECTS"));
        }
    }, [token])

    const getExpenseList = (
        offset: number,
        keyword?: string,
        startDate?: Date,
        endDate?: Date,
        order_by?: string,
        sort_by?: string
    ) => {
        nextOffset.current = offset;
        if (nextOffset.current < 0 || isLoading) {
            return;
        }
        setIsLoading(true);
        WebService.getAPI({
            action: `booked-units/pagination/list?limit=10&offset=${offset}&keyword=${keyword ? keyword : ""
                }&sort_by=${order_by ?? "asc"}&order_by=${sort_by ?? "created_at"}&from_date=${startDate ? startDate : ""}&to_date=${endDate ? endDate : ""
                }`,
            body: null,
        })
            .then((res: any) => {
                setIsLoading(false);
                let temp: any = [];
                for (let i in res.list) {
                    let index: number = 0;
                    temp.push({ header: getHeader(res.list[i]), isExpand: false, data: [], key: res.list[i], class: "d-flex" });
                    index = temp.length - 1;
                    let data: any[] = [];

                    for (let j in res.list[i].booked_units) {
                        data.push({
                            data: [
                                { value: res.list[i].booked_units[j].unit_name ? res.list[i].booked_units[j].unit_name : "-" },
                                { value: res.list[i].booked_units[j]?.area ? res.list[i].booked_units[j]?.area : "-" },
                                { value: res.list[i].booked_units[j]?.created_at ? HelperService.getFormatedDate(res.list[i].booked_units[j]?.created_at) : "N/A" }
                            ]
                        });
                    };
                    temp[index].data = data;
                };

                setRows(temp);

            })
            .catch((e) => {
                setIsLoading(false);
            });
    };

    const getHeader = (data: any) => {
        return (
            <div className="d-flex justify-content-between align-items-center w-100">
                <div className="fw-500">{data.project_name}</div>
            </div>
        );
    };


    return (
        <>
            {permissions && permissions.can_read && <div className="app-page page-dashboard">
                <div className="d-flex justify-content-between align-items-center ">
                    <PageTitle title="Booked Units" backArrow={true} />
                </div>
                <div className="table-card">
                    <ExpandableGrid
                        rows={rows}
                        headers={headers}
                        errorMessage={"No Data Found"}
                        ShowLoader={isLoading}
                    />
                </div>
            </div>}
        </>
    );
};

export default BookedUnits;
